import { AutoComplete } from 'antd';
import React, { useState } from 'react';
import style from "./props.module.sass";
import { autoCompleteI18NData } from "./commonFunctions";
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useToast } from '../../../../../../helpers/commonFunction';
import { AppState } from '../../../../../../stateManager/store';

interface CustomAutoCompleteProps {
    dataTestId?: string;
    disabled?: boolean;
    value?: any;
    defaultValue?: any;
    onBlur?: () => void;
    onChange?: (val: any) => void;
    onSelect?: (val:any) => void;
    placeholder?: string;
}

const CustomAutoComplete = (props: CustomAutoCompleteProps) => {
    const {dataTestId, disabled, value, defaultValue, placeholder, onBlur} = props;
    const { version: formVersion } = useSelector(
        (state: AppState) => state.formJson
    );
    const parentStyles: React.CSSProperties = {
        ...formVersion !== "v2" ? { border: "1px solid #052f35 ", borderRadius: "4px" } : {  },
    }
    const [autoCompleteData, setAutoCompleteData] = useState<any>()
    const params: any = useParams();
    const version = useSelector(
        (state: any) => state.apps.appVersion[params["appId"]]
    );
    const { selectedOrg } = useSelector((state: AppState) => state.org)
    const loggedInUserId = useSelector((state: any) => {
        return state.user.data.user.id
    })
    const { ErrorToast } = useToast()
    const orgPermissions: any = useSelector((state: any) => {
        return state.org.orgPermissions
    }, (oldPermissions: any, newPermissions: any) => JSON.stringify(oldPermissions) === JSON.stringify(newPermissions))

    const i18nSuggestion = async (search: string) => {
        try {
            if ((!orgPermissions?.includes("i18n.View")|| !orgPermissions?.includes("app.View")) && loggedInUserId!=selectedOrg?.owner) {
                ErrorToast('Not Authorized: Please request owner of this organization to provide access')
                return
            }
            let data = await autoCompleteI18NData(params["appId"], version.versionId, search);
            setAutoCompleteData(data)
        } catch (e) {
            console.log(e)
        }
    };

    return (
        <AutoComplete
            className='autocomplete'
            data-test-id={dataTestId}
            dropdownMatchSelectWidth={false}
            style={parentStyles}
            dropdownMenuStyle={{ maxWidth: '260px', maxHeight: '314px', borderRadius: "2px", boxShadow: '0px 6px 10px #D7D9E5' }}
            disabled={disabled}
            dataSource={autoCompleteData && autoCompleteData.map((data: any) => (
                <div key={data.key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center', fontFamily: 'Inter', fontWeight: 400, fontSize: 13, height: 60, paddingBottom: 3 }}>
                    <div style={{ color: '#3461A2' }}>{data.key}</div>
                    <div style={{ color: '#393939', paddingBottom: 4 }}>{data.value}</div>
                    <div style={{ borderTop: '1px solid #BEC1C8', width: '100%' }}></div>
                </div>
            ))}
            onChange={(e: any) => {
                const regexPattern = /^\$i18n\./;
                if (e.length >= 8) {
                    if (regexPattern.test(e)) {
                        i18nSuggestion(e.slice(6));
                    }
                } else {
                    setAutoCompleteData([]);
                }
                props.onChange && props.onChange(e)
            }}
            placeholder={placeholder}
            value={value}
            defaultValue={defaultValue}
            onSelect={(e) =>{
                props.onChange && props.onChange('$i18n.' + e)}}
            onBlur={onBlur}
            autoFocus={!disabled}
        />
    );
};

export default CustomAutoComplete;